<div class="modal-header border-0 px-lg-5 px-2">
	<span class="modal-title theme-main-color fs-4 fw-bold ms-2 mt-3"
		>Ajout d'un intervenant</span
	>
	<button
		type="button"
		class="btn-close"
		data-bs-dismiss="modal"
		aria-label="Close"
		(click)="bsModalRef.hide()"
	></button>
</div>

<div class="modal-body">
	<div class="row px-lg-5 px-2">
		<div class="">
			<div class="row">
				<span class="theme-main-color fs-4 col">Informations</span>
			</div>
			<div class="row my-2">
				<app-employee-form
					[employee]="employee"
					[isAddForm]="true"
					[form]="formAjout"
					[isAddressSelected]="isAddressSelected"
					[isAddressDefault]="isAddressDefault"
					(sendForm)="onSubmit()"
					(hideModal)="bsModalRef.hide()"
					[isValidateButtonClicked]="isValidateButtonClicked"
				></app-employee-form>
			</div>
		</div>
	</div>
</div>
